import Tooltip from '@mui/material/Tooltip';

const columns = (
  renderCell,
) => [
  {
    field: 'Rig',
    headerName: 'Rig',
    width: 300,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          {params.value}
        </div>
      </Tooltip>
    ),
    hide: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'Well',
    headerName: 'Well',
    width: 300,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          {params.value}
        </div>
      </Tooltip>
    ),
    hide: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'SN',
    headerName: 'SN',
    width: 100,
    hide: false,
    renderCell,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'Type',
    headerName: 'Type',
    width: 100,
    hide: false,
    renderCell,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'Latitude',
    headerName: 'Latitude',
    width: 200,
    hide: false,
    renderCell,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'Longitude',
    headerName: 'Longitude',
    width: 200,
    hide: false,
    renderCell,
    headerAlign: 'center',
    align: 'center',
  },
];

export default columns;
